export default __webpack_public_path__ + "static/tubachat-b0f373b4e24507f516f607e3644f621c.jpg";